import React, { useEffect, useRef, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  TablePagination,
  TextField,
  Tooltip,
  Button,
  IconButton,
  Typography,
  Dialog,
  DialogContent,
  LinearProgress,
  DialogTitle,
  DialogActions,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Popover,
  CircularProgress,
  Alert,
  Stack,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Autocomplete,
  Divider,
  Snackbar,
} from "@mui/material";
import ReceiptIcon from "@mui/icons-material/Receipt";
import DynamicFeedIcon from "@mui/icons-material/DynamicFeed";
import FormatAlignLeftIcon from "@mui/icons-material/FormatAlignLeft";
import DeleteSweepIcon from "@mui/icons-material/DeleteSweep";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import noData from "../../images/noData.jpg";
import EastIcon from "@mui/icons-material/East";
import { useNavigate } from "react-router-dom";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
import DescriptionIcon from "@mui/icons-material/Description";
import Avatar from "@mui/material/Avatar";
import Chip from "@mui/material/Chip";
import RefreshIcon from "@mui/icons-material/Refresh";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { BASE_URL, TARGET_TYPE } from "../../constants";
import ContentPasteSearchIcon from "@mui/icons-material/ContentPasteSearch";
import parse from "autosuggest-highlight/parse";
import match from "autosuggest-highlight/match";
import PrintIcon from "@mui/icons-material/Print";
import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";
import { createInvoice, createAdvice, createBoth } from "./createPdf";
import { useRecoilState, useRecoilValue } from "recoil";
import { authState } from "../../recoil/authAtom";
import Log from "../logDialog/Log";
import DiscountIcon from "@mui/icons-material/LocalOfferOutlined";
import EditNoteIcon from "@mui/icons-material/EditNoteOutlined";
import SwapHorizIcon from "@mui/icons-material/SwapHorizOutlined";
import { toast } from "react-toastify";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import {
  formattedFromDateState,
  formattedToDateState,
  fromDateState,
  invoiceDiscountState,
  invoiceDueState,
  invoiceGTotalState,
  invoicesLoadedState,
  invoicesState,
  invoiceTotalState,
  rowLoadingState,
  submitStatusState,
  toDateState,
} from "../../recoil/invoiceLoadedState";
const getFormattedCurrentDate = () => {
  const today = new Date();
  const day = today.getDate();
  const month = today.toLocaleString("en-US", { month: "long" });
  const year = today.getFullYear();
  const formattedDay = day < 10 ? `0${day}` : day;

  return `${month} ${formattedDay}, ${year}`;
};
const getFormattedDate = () => {
  const today = new Date();
  return today.toISOString().split("T")[0]; // Extracts YYYY-MM-DD from ISO format
};
const Invoices = () => {
  const navigate = useNavigate();
  const user = useRecoilValue(authState);

  const [invoicesLoaded, setInvoicesLoaded] =
    useRecoilState(invoicesLoadedState);
  const [invoices, setInvoices] = useRecoilState(invoicesState);
  const [invoiceTotal, setInvoiceTotal] = useRecoilState(invoiceTotalState);
  const [invoiceGTotal, setInvoiceGTotal] = useRecoilState(invoiceGTotalState);
  const [invoiceDiscount, setInvoiceDiscount] =
    useRecoilState(invoiceDiscountState);
  const [invoiceDue, setInvoiceDue] = useRecoilState(invoiceDueState);
  const [submitStatus, setSubmitStatus] = useRecoilState(submitStatusState);
  const [fromDate, setFromDate] = useRecoilState(fromDateState);
  const [toDate, setToDate] = useRecoilState(toDateState);
  const [rowLoading, setRowLoading] = useRecoilState(rowLoadingState);
  const [formattedFromDate, setFormattedFromDate] = useRecoilState(
    formattedFromDateState,
  );
  const [formattedToDate, setFormattedToDate] =
    useRecoilState(formattedToDateState);

  // const [invoices, setInvoices] = useState([]);
  // const [loading, setLoading] = useState(false);
  // const [rowLoading, setRowLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  // const [invoiceTotal, setInvoiceTotal] = useState(0);
  // const [invoiceDue, setInvoiceDue] = useState(0);
  // const [fromDate, setFromDate] = useState(getFormattedDate());
  // const [toDate, setToDate] = useState(getFormattedDate());
  // const [formattedFromDate, setFormattedFromDate] = useState(
  //   getFormattedCurrentDate()
  // );
  // const [formattedToDate, setFormattedToDate] = useState(
  //   getFormattedCurrentDate()
  // );
  // const [submitStatus, setSubmitStatus] = useState(false);

  // Function to format the date to "January 25, 2025"
  const formatDateToReadableString = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    const day = date.getDate();
    const month = date.toLocaleString("en-US", { month: "long" });
    const year = date.getFullYear();
    const formattedDay = day < 10 ? `0${day}` : day;
    return `${month} ${formattedDay}, ${year}`;
  };

  const handleEdit = (inv) => {
    const invoice = {
      ...inv,
      isEdit: true,
      fromCentreRef: false,
    };
    navigate("/dashboard/bills", { state: { invoice } });
  };

  const handleDelete = async (invoiceId, id) => {
    const isConfirmed = window.confirm(
      `Are you sure you want to delete ${invoiceId} invoice?`,
    );
    if (!isConfirmed) {
      return;
    }
    try {
      const response = await fetch(
        `${BASE_URL}api/user/common/invoice-delete/${id}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      const data = await response.json();
      if (data.success) {
        alert(data.message);
        setInvoices(invoices.filter((invoice) => invoice._id !== id));
      } else {
        alert(`Error: ${data.message}`);
      }
    } catch (error) {
      alert("An unexpected error occurred while deleting the doctor.");
    }
  };

  const [collectedAmt, setCollectedAmt] = useState(null);
  const [amtLoading, setAmtLoading] = useState(false);

  const handleCollectAmtSubmit = async (invoiceId) => {
    if (collectedAmt === null) {
      toast.warning("Please enter an amount");
      return;
    }
    const diffAmt = parseInt(collectedAmt) - invoiceId?.amountCollected;
    if (diffAmt === 0) {
      toast.error("The collected amount and new amount are same");
      return;
    }
    try {
      setAmtLoading(true);
      const response = await fetch(
        `${BASE_URL}api/user/common/update-invoice-collectedAmt/${invoiceId?._id}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            collectedAmt: parseInt(diffAmt),
          }),
        },
      );
      const data = await response.json();
      if (data.success) {
        toast.success(data.message);
        setChangeAmtOpen(false);
        setInvoices((prevInvoices) =>
          prevInvoices.map((invoice) => {
            if (invoice._id === invoiceId?._id) {
              const targetDue =
                invoice.due - diffAmt > 0 ? invoice.due - diffAmt : 0;
              animateDueAmount(invoice._id, invoice.due, targetDue);
              return {
                ...invoice,
                amountCollected: invoice?.amountCollected + diffAmt,
              };
            }
            return invoice;
          }),
        );
      } else {
        toast.error(`Error: ${data.message}`);
      }
    } catch (error) {
      toast.error("An unexpected error occurred while deleting the doctor.");
    } finally {
      setCollectedAmt(null);
      setAmtLoading(false);
    }
  };
  // const fetchAllinvoices = async () => {
  //   setRowLoading(true);
  //   try {
  //     const response = await fetch(
  //       `${BASE_URL}api/user/common/get-all-invoices?startDate=${formattedFromDate}&endDate=${formattedToDate}`,
  //       {
  //         method: "GET",
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     );
  //     const data = await response.json();
  //     const reqData = data?.invoices?.map((invoice) => {
  //       return {
  //         _id: invoice._id,
  //         invoiceId: invoice?.invoiceId,
  //         billingDate: invoice.billingDate,
  //         doctorName: invoice?.doctorId?.name,
  //         patientName: invoice?.patientId?.name,
  //         invoiceNote: invoice?.invoiceNote,
  //         total: invoice?.total,
  //         isAmountCollectedAtCenter: invoice?.isAmountCollectedAtCenter,
  //         due: invoice?.due,
  //         doctor: invoice?.doctorId,
  //         patient: invoice?.patientId,
  //         center: invoice?.centerId,
  //         centerName: invoice?.centerId?.centreName,
  //         tests: invoice?.tests,
  //         invoiceDiscount: invoice?.invoiceDiscount,
  //         amountCollected: invoice?.amountCollected,
  //         billingDate: invoice?.billingDate,
  //         isMicroSubmit: invoice?.isMicroSubmit,
  //         isPathSubmit: invoice?.isPathSubmit,
  //         isRadioSubmit: invoice?.isRadioSubmit,
  //         isWidSubmit: invoice?.isWidSubmit,
  //         allowEdit: invoice?.allowEdit,
  //       };
  //     });
  //     const invTotal = data?.invoices?.reduce(
  //       (sum, invoice) => sum + invoice.total,
  //       0
  //     );
  //     const invDue = data?.invoices?.reduce(
  //       (sum, invoice) => sum + invoice.due,
  //       0
  //     );
  //     const allSubmitted = reqData?.every(
  //       (inv) =>
  //         inv.isMicroSubmit &&
  //         inv.isPathSubmit &&
  //         inv.isRadioSubmit &&
  //         inv.isWidSubmit
  //     );
  //     setSubmitStatus(allSubmitted);
  //     setInvoices(reqData);
  //     setInvoiceTotal(invTotal);
  //     setInvoiceDue(invDue);
  //   } catch (error) {
  //     toast.error("Something went wrong! Please try again.");
  //   } finally {
  //     setRowLoading(false);
  //   }
  // };
  const fetchAllinvoices1 = async () => {
    setRowLoading(true);
    try {
      const response = await fetch(
        `${BASE_URL}api/user/common/get-all-invoices?startDate=${formattedFromDate}&endDate=${formattedToDate}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      const data = await response.json();
      if (data.success) {
        const reqData = data?.invoices?.map((invoice) => ({
          _id: invoice._id,
          invoiceId: invoice?.invoiceId,
          billingDate: invoice.billingDate,
          doctorName: invoice?.doctorId?.name,
          patientName: invoice?.patientId?.name,
          invoiceNote: invoice?.invoiceNote,
          calculations: invoice?.calculations,
          isAmountCollectedAtCenter: invoice?.isAmountCollectedAtCenter,
          due: invoice?.due,
          doctor: invoice?.doctorId,
          patient: invoice?.patientId,
          center: invoice?.centerId,
          centerName: invoice?.centerId?.centreName,
          tests: invoice?.tests,
          invoiceDiscount: invoice?.invoiceDiscount,
          amountCollected: invoice?.amountCollected,
          billingDate: invoice?.billingDate,
          isMicroSubmit: invoice?.isMicroSubmit,
          isPathSubmit: invoice?.isPathSubmit,
          isRadioSubmit: invoice?.isRadioSubmit,
          isWidSubmit: invoice?.isWidSubmit,
          allowEdit: invoice?.allowEdit,
        }));

        const invTotal = data?.invoices?.reduce(
          (sum, invoice) => sum + invoice.calculations.finalTotal,
          0,
        );

        const invDue = data?.invoices?.reduce(
          (sum, invoice) => sum + invoice.due,
          0,
        );

        const invGTotal = data?.invoices?.reduce(
          (sum, invoice) => sum + invoice.calculations.grandTotal,
          0,
        );

        const invDicount = data?.invoices?.reduce(
          (sum, invoice) => sum + invoice.calculations.totalDiscountOffered,
          0,
        );
        const allSubmitted = reqData?.every(
          (inv) =>
            inv.isMicroSubmit &&
            inv.isPathSubmit &&
            inv.isRadioSubmit &&
            inv.isWidSubmit,
        );

        setSubmitStatus(allSubmitted);
        setInvoices(reqData);
        setInvoiceTotal(invTotal);
        setInvoiceGTotal(invGTotal);
        setInvoiceDiscount(invDicount);
        setInvoiceDue(invDue);
        setInvoicesLoaded(true);
      } else if (data.success === false) {
        setSubmitStatus(false);
        setInvoices([]);
        setInvoiceTotal(0);
        setInvoiceDue(0);
        setInvoiceGTotal(0);
        setInvoiceDiscount(0);
        setInvoicesLoaded(true);
      }
    } catch (error) {
      toast.error("Something went wrong! Please try again.");
    } finally {
      setRowLoading(false);
    }
  };
  const [cache, setCache] = useState({});
  const [totalInvoiceCount, setTotalInvoiceCount] = useState(0);
  const fetchAllinvoices = async (page = 0, limit = 10, query = "") => {
    setRowLoading(true);

    try {
      // ================== ✅ DATE RANGE VALIDATION ==================
      if (formattedFromDate && formattedToDate) {
        const from = new Date(formattedFromDate);
        const to = new Date(formattedToDate);

        const diffTime = Math.abs(to - from);
        const diffDays = diffTime / (1000 * 60 * 60 * 24);

        if (diffDays > 92) {
          toast.error("You can select maximum 3 months date range");
          setRowLoading(false);
          return;
        }
      }
      const cacheKey = `${query}_${page}_${limit}_${formattedFromDate}_${formattedToDate}`;

      // ✅ API endpoint
      const endpoint = query
        ? `${BASE_URL}api/user/common/search-invoices?query=${encodeURIComponent(
            query,
          )}&page=${page}&limit=${limit}&startDate=${formattedFromDate}&endDate=${formattedToDate}`
        : `${BASE_URL}api/user/common/get-all-invoices?page=${page}&limit=${limit}&startDate=${formattedFromDate}&endDate=${formattedToDate}`;

      const response = await fetch(endpoint, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();

      if (data.success) {
        // ✅ Map invoices (ONLY paginated data)
        const reqData = data?.invoices?.map((invoice) => ({
          _id: invoice._id,
          invoiceId: invoice?.invoiceId,
          billingDate: invoice.billingDate,
          doctorName: invoice?.doctorId?.name,
          patientName: invoice?.patientId?.name,
          invoiceNote: invoice?.invoiceNote,
          calculations: invoice?.calculations,
          isAmountCollectedAtCenter: invoice?.isAmountCollectedAtCenter,
          due: invoice?.due,
          doctor: invoice?.doctorId,
          patient: invoice?.patientId,
          center: invoice?.centerId,
          centerName: invoice?.centerId?.centreName,
          tests: invoice?.tests,
          invoiceDiscount: invoice?.invoiceDiscount,
          amountCollected: invoice?.amountCollected,
          isMicroSubmit: invoice?.isMicroSubmit,
          isPathSubmit: invoice?.isPathSubmit,
          isRadioSubmit: invoice?.isRadioSubmit,
          isWidSubmit: invoice?.isWidSubmit,
          allowEdit: invoice?.allowEdit,
        }));

        // =====================================================
        // 🔥 USE TOTALS FROM BACKEND (NOT PAGINATED DATA)
        // =====================================================
        const invTotal = data?.totals?.finalTotal || 0;
        const invDue = data?.totals?.due || 0;
        const invGTotal = data?.totals?.grandTotal || 0;
        const invDiscount = data?.totals?.discount || 0;

        // ✅ Check submission status (only for current page)
        const allSubmitted = reqData?.every(
          (inv) =>
            inv.isMicroSubmit &&
            inv.isPathSubmit &&
            inv.isRadioSubmit &&
            inv.isWidSubmit,
        );

        // ✅ Cache result
        setCache((prev) => ({
          ...prev,
          [cacheKey]: {
            data: reqData,
            totalCount: data.totalCount,
            invTotal,
            invDue,
            invGTotal,
            invDiscount,
            allSubmitted,
          },
        }));

        // ✅ Set states
        setInvoices(reqData);
        setTotalInvoiceCount(data.totalCount || 0);

        setInvoiceTotal(invTotal);
        setInvoiceGTotal(invGTotal);
        setInvoiceDiscount(invDiscount);
        setInvoiceDue(invDue);
        setSubmitStatus(allSubmitted);

        setInvoicesLoaded(true);
      } else {
        // ❌ Reset
        setInvoices([]);
        setTotalInvoiceCount(0);
        setInvoiceTotal(0);
        setInvoiceDue(0);
        setInvoiceGTotal(0);
        setInvoiceDiscount(0);
        setSubmitStatus(false);
        setInvoicesLoaded(true);
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong! Please try again.");
    } finally {
      setRowLoading(false);
    }
  };

  // useEffect(() => {
  //   fetchAllinvoices(page, rowsPerPage, searchQuery);
  // }, [formattedFromDate, formattedToDate]);

  const handleReload = () => {
    setPage(0);
    fetchAllinvoices(0, rowsPerPage, searchQuery);
  };

  useEffect(() => {
    const delay = setTimeout(() => {
      fetchAllinvoices(0, rowsPerPage, searchQuery);
    }, 400);

    return () => clearTimeout(delay);
  }, [searchQuery]);

  const handleSearchInvoice = () => {
    fetchAllinvoices();
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    fetchAllinvoices(newPage, rowsPerPage, searchQuery);
  };

  const handleChangeRowsPerPage = (event) => {
    const newLimit = parseInt(event.target.value, 10);

    setRowsPerPage(newLimit);
    setPage(0);

    fetchAllinvoices(0, newLimit, searchQuery);
  };

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchQuery(value);
    setPage(0);
  };
  const [printLoading, setPrintLoading] = useState(false);
  const printInvoice = async (id) => {
    setPrintLoading(true);
    try {
      const response = await fetch(
        `${BASE_URL}api/user/common/get-invoice/${selectedInvoiceToPrint}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      const data = await response.json();
      createInvoice(data.invoice, paperSize, orientation);
      logPrintInvoice(data.invoice._id);
    } catch (error) {
      console.log(error);
      alert("Something went wrong! Please try again.");
    } finally {
      setPrintLoading(false);
    }
  };
  const printAdvice = async (id) => {
    setPrintLoading(true);
    try {
      const response = await fetch(
        `${BASE_URL}api/user/common/get-invoice/${selectedAdviceToPrint}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      const data = await response.json();
      createAdvice(data.invoice, paperSize, orientation);
      logPrintAdvice(data.invoice._id);
    } catch (error) {
      alert("Something went wrong! Please try again.");
    } finally {
      setPrintLoading(false);
    }
  };
  const printBoth = async (id) => {
    setPrintLoading(true);
    try {
      const response = await fetch(
        `${BASE_URL}api/user/common/get-invoice/${id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      const data = await response.json();
      // createInvoice(data.invoice, paperSize, orientation);
      // createAdvice(data.invoice, paperSize, orientation);
      createBoth(data.invoice, paperSize, orientation);
      logPrintBoth(data.invoice._id);
    } catch (error) {
      alert("Something went wrong! Please try again.");
    } finally {
      setPrintLoading(false);
    }
  };

  const logPrintBoth = async (id) => {
    try {
      const response = await fetch(`${BASE_URL}api/user/common/log-print`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id, print: "Both" }),
      });
    } catch (error) {
      console.log(error);
    }
  };
  const [openModal, setOpenModal] = useState(false);
  const [selectedInvoiceToPrint, setSelectedInvoiceToPrint] = useState("");
  const [selectedAdviceToPrint, setSelectedAdviceToPrint] = useState("");
  const [paperSize, setPaperSize] = useState("a5");
  const [orientation, setOrientation] = useState("landscape");
  const handleInvoiceClick = async (id) => {
    setOpenModal(true);
    setSelectedAdviceToPrint("");
    setSelectedInvoiceToPrint(id);
  };
  const handleAdviceClick = async (id) => {
    setOpenModal(true);
    setSelectedInvoiceToPrint("");
    setSelectedAdviceToPrint(id);
  };
  const handleBothClick = async (id) => {
    printBoth(id);
    // printAdvice(id);
  };

  const [editingRow, setEditingRow] = useState(null);
  const [amount, setAmount] = useState("");
  const [dateInputVisible, setDateInputVisible] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const amountInputRef = useRef(null);
  const dateInputRef = useRef(null);

  const getCurrentDate = () => {
    const today = new Date();
    const day = String(today.getDate()).padStart(2, "0");
    const month = String(today.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const year = today.getFullYear();
    return `${day}-${month}-${year}`; // Format to 'DD-MM-YYYY'
  };

  const formatDateForInput = (dateStr) => {
    const [day, month, year] = dateStr.split("-");
    return `${year}-${month}-${day}`; // Convert to 'YYYY-MM-DD' for input field compatibility
  };

  useEffect(() => {
    setSelectedDate(getCurrentDate());
  }, [amount]);

  const handleCollectClick = (index) => {
    setEditingRow(index);
    setDateInputVisible(false);
    setTimeout(() => amountInputRef.current?.focus(), 100);
  };

  const handleConfirmAmount = () => {
    setDateInputVisible(true);
    setTimeout(() => dateInputRef.current?.focus(), 100);
  };

  const handleCancelInput = () => {
    setEditingRow(null);
    setAmount("");
    setSelectedDate("");
    setDateInputVisible(false);
  };

  const handleConfirmDate = (id) => {
    handleAmtSubmit(id, amount, selectedDate);
    setEditingRow(null);
    setAmount("");
    setSelectedDate("");
    setDateInputVisible(false);
  };

  const handleAmtSubmit = async (id, amount, selectedDate) => {
    const data = {
      paidAmount: amount,
      paidAmountDate: selectedDate,
    };
    try {
      const response = await fetch(
        `${BASE_URL}api/user/common/insert-paid-amt-invoice/${id}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        },
      );

      const resp = await response.json();
      if (resp.success) {
        toast.success(resp.message);
        setInvoices((prevInvoices) =>
          prevInvoices.map((invoice) => {
            if (invoice._id === id) {
              const targetDue =
                invoice.due - amount > 0 ? invoice.due - amount : 0;
              animateDueAmount(invoice._id, invoice.due, targetDue);
              return {
                ...invoice,
                amountCollected: resp.invoice.amountCollected,
              }; // Keep the same object until animation completes
            }
            return invoice;
          }),
        );
      } else {
        toast.error("Error: " + resp.message);
      }
    } catch (error) {
      toast.error("Something went wrong! Please try again.");
    } finally {
    }
  };

  // useEffect(() => {
  //   const totalDue = invoices?.reduce((sum, invoice) => sum + invoice.due, 0);
  //   animateTotalDue(invoiceDue, totalDue);
  // }, [invoices]);

  // const animateTotalDue = (startValue, endValue) => {
  //   if (startValue === endValue) return;

  //   let currentValue = startValue;
  //   const step = (startValue - endValue) / 5;

  //   const interval = setInterval(() => {
  //     currentValue -= step;
  //     if (
  //       (startValue > endValue && currentValue <= endValue) ||
  //       (startValue < endValue && currentValue >= endValue)
  //     ) {
  //       clearInterval(interval);
  //       currentValue = endValue;
  //     }
  //     setInvoiceDue(Math.round(currentValue));
  //   }, 5);
  // };

  const animateDueAmount = (invoiceId, startValue, endValue) => {
    let currentValue = startValue;
    const step = (startValue - endValue) / 5;

    const interval = setInterval(() => {
      currentValue -= step;

      setInvoices((prevInvoices) =>
        prevInvoices.map((invoice) =>
          invoice._id === invoiceId
            ? { ...invoice, due: Math.max(Math.round(currentValue), endValue) }
            : invoice,
        ),
      );

      if (currentValue <= endValue) {
        clearInterval(interval);
      }
    }, 5);
  };

  const animateTotalAmount = (invoiceId, startValue, endValue) => {
    let currentValue = startValue;
    const step = (startValue - endValue) / 5; // Smaller values for smoother effect

    const interval = setInterval(() => {
      currentValue -= step;

      setInvoices((prevInvoices) =>
        prevInvoices.map((invoice) =>
          invoice._id === invoiceId
            ? {
                ...invoice,
                total: Math.max(Math.round(currentValue), endValue),
              }
            : invoice,
        ),
      );

      if (currentValue <= endValue) {
        clearInterval(interval);
      }
    }, 5); // Adjust speed by changing interval time
  };

  const logPrintInvoice = async (id) => {
    try {
      const response = await fetch(`${BASE_URL}api/user/common/log-print`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id, print: "Invoice" }),
      });
    } catch (error) {
      console.log(error);
    }
  };
  const logPrintAdvice = async (id) => {
    try {
      const response = await fetch(`${BASE_URL}api/user/common/log-print`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id, print: "Advice" }),
      });
    } catch (error) {
      console.log(error);
    }
  };

  const [openLogDialog, setOpenLogDialog] = useState(false);
  const [invoiceLogs, setInvoiceLogs] = useState(null);
  const handleViewLog = async (id) => {
    setOpenLogDialog(true);
    try {
      const response = await fetch(
        `${BASE_URL}api/user/common/get-logs?id=${id}&targetType=${TARGET_TYPE.invoice}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      const invoice = await response.json();
      setInvoiceLogs(invoice.logs);
    } catch (error) {
      console.error("Error:", error);
      alert("Something went wrong! Please try again.");
    } finally {
      // setLoading(false);
    }
  };
  const handleCloseLog = () => {
    setOpenLogDialog(false);
  };

  const [printAnchorEls, setPrintAnchorEls] = useState({});
  const [actionAnchorEls, setActionAnchorEls] = useState({});
  const [moreAnchorEls, setMoreAnchorEls] = useState({});
  const [applyDiscountOpen, setApplyDiscountOpen] = useState(false);
  const [changeAmtOpen, setChangeAmtOpen] = useState(false);
  const [changeDocCentOpen, setChangeDocCentOpen] = useState(false);
  const [selectInvoiceForMore, setSelectInvoiceForMore] = useState(null);
  const [newDiscount, setNewDiscount] = useState(null);
  const [newDiscountType, setNewDiscountType] = useState("₹");
  // Print popover handlers
  const handlePrintClick = (e, invoiceId) => {
    setPrintAnchorEls((prev) => ({ ...prev, [invoiceId]: e.currentTarget }));
  };
  const handlePrintClose = (invoiceId) => {
    setPrintAnchorEls((prev) => ({ ...prev, [invoiceId]: null }));
  };

  // Action popover handlers
  const handleActionClick = (e, invoiceId) => {
    setActionAnchorEls((prev) => ({ ...prev, [invoiceId]: e.currentTarget }));
  };
  const handleActionClose = (invoiceId) => {
    setActionAnchorEls((prev) => ({ ...prev, [invoiceId]: null }));
  };

  // More popover handlers
  const handleMoreClick = (e, id, invoice) => {
    setMoreAnchorEls((prev) => ({ ...prev, [id]: e.currentTarget }));
    setSelectInvoiceForMore(invoice);
  };

  const handleMoreClose = (id) => {
    setMoreAnchorEls((prev) => ({ ...prev, [id]: null }));
  };

  const handleDiscountSubmit = async (invoiceId) => {
    const invoiceDiscount = {
      type: newDiscountType,
      value: parseInt(newDiscount),
    };
    try {
      const response = await fetch(
        `${BASE_URL}api/user/common/update-invoice-discount/${invoiceId?._id}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(invoiceDiscount),
        },
      );
      const data = await response.json();
      if (data.success) {
        toast.success(data.message);
        setInvoices((prevInvoices) =>
          prevInvoices.map((invoice) => {
            if (invoice._id === invoiceId?._id) {
              const targetDue =
                invoice.due - amount > 0 ? invoice.due - amount : 0;
              // animateDueAmount(invoice._id, invoice.due, targetDue);
              // animateTotalAmount(invoice._id, invoice.total, targetTotal);
              return {
                ...invoice,
                due: data.invoice.due,
                total: data.invoice.total,
              };
            }
            return invoice;
          }),
        );
        setApplyDiscountOpen(false);
        setNewDiscount(null);
        setNewDiscountType("₹");
      } else {
        toast.error(`Error: ${data.message}`);
      }
    } catch (error) {
      toast.error("An unexpected error occurred.");
    }
  };

  const [centerSearchInput, setCenterSearchInput] = useState("");
  const [centerSuggestions, setCenterSuggestions] = useState([]);
  const [loadingCenters, setLoadingCenters] = useState(false);
  const [newCentre, setNewCentre] = useState(null);
  const [newDoctor, setNewDoctor] = useState(null);

  useEffect(() => {
    setLoadingCenters(false);
    if (centerSearchInput.trim()) {
      setLoadingCenters(true);
      const delayDebounce = setTimeout(async () => {
        try {
          const res = await fetch(
            `${BASE_URL}api/user/common/centers/search?query=${centerSearchInput}`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
              },
            },
          );
          const centers = await res.json();
          setCenterSuggestions(centers.data);
        } catch (err) {
          console.error("Error fetching centers:", err);
          setCenterSuggestions([]);
        } finally {
          setLoadingCenters(false);
        }
      }, 500); // debounce

      return () => clearTimeout(delayDebounce);
    } else {
      setCenterSuggestions([]);
    }
  }, [centerSearchInput]);

  const handleSelectCenter = async (event, newValue) => {
    if (newValue?._id) {
      setNewCentre(newValue._id);
    }
  };

  const [doctorSearchInput, setDoctorSearchInput] = useState("");
  const [doctorSuggestions, setDoctorSuggestions] = useState([]);
  const [loadingDoctors, setLoadingDoctors] = useState(false);
  useEffect(() => {
    setLoadingDoctors(false);
    if (doctorSearchInput.trim()) {
      setLoadingDoctors(true);
      const delayDebounce = setTimeout(async () => {
        try {
          const res = await fetch(
            `${BASE_URL}api/user/common/doctors/search?query=${doctorSearchInput}`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
              },
            },
          );
          const doctors = await res.json();
          setDoctorSuggestions(doctors.data);
        } catch (err) {
          console.error("Error fetching doctors:", err);
          setDoctorSuggestions([]);
        } finally {
          setLoadingDoctors(false);
        }
      }, 500); // debounce

      return () => clearTimeout(delayDebounce);
    } else {
      setDoctorSuggestions([]);
    }
  }, [doctorSearchInput]);

  const handleSelectDoctor = async (event, newValue) => {
    if (newValue?._id) {
      setNewDoctor(newValue?._id);
    }
  };

  const [loadingDocCent, setLoadingDocCent] = useState(false);
  const changeDoctorCentre = async () => {
    setLoadingDocCent(true);
    const data = {
      invoiceId: selectInvoiceForMore?._id,
      newDoctor,
      newCentre,
    };
    console.log(data);
    try {
      const response = await fetch(
        `${BASE_URL}api/user/common/change-doctor-centre`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        },
      );
      const resp = await response.json();
      if (resp?.success) {
        const reports = resp?.data?.reportsUpdated || {};
        const reportsMessage = `✨📊 Report Updated:\n• Pathology: ${
          reports?.pathology || 0
        }\n• Radiology: ${reports?.radiology || 0}\n• Microbiology: ${
          reports?.microbiology || 0
        }`;

        toast.success(resp?.message);
        toast.info(reportsMessage);

        setInvoices((prevInvoices) =>
          prevInvoices.map((invoice) => {
            if (invoice._id === selectInvoiceForMore?._id) {
              return {
                ...invoice,
                doctor: resp?.data?.updatedInvoice?.doctorId,
                doctorName: resp?.data?.updatedInvoice?.doctorId?.name,
                center: resp?.data?.updatedInvoice?.centerId,
                centerName: resp?.data?.updatedInvoice?.centerId?.centreName,
              };
            }
            return invoice;
          }),
        );
        setChangeDocCentOpen(false);
      } else toast.error(resp?.message);
    } catch (error) {
      console.log(error);
      toast.error("Soemthing went wrong");
    } finally {
      setLoadingDocCent(false);
    }
  };
  return (
    <Box>
      <Dialog
        open={applyDiscountOpen}
        onClose={() => setApplyDiscountOpen(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>Apply Discount</DialogTitle>

        <Box sx={{ px: 3, pt: 2 }}>
          <Stack spacing={2}>
            {/* Row 1: Current Discount and Type */}
            <Stack direction="row" spacing={2}>
              <TextField
                label="Current Discount"
                value={selectInvoiceForMore?.invoiceDiscount?.value || 0}
                disabled
                fullWidth
                size="small"
              />
              <TextField
                label="Type"
                value={selectInvoiceForMore?.invoiceDiscount?.type || ""}
                disabled
                fullWidth
                size="small"
              />
            </Stack>

            {/* Row 2: New Discount and New Type */}
            <Stack direction="row" spacing={2}>
              <TextField
                label="New Discount"
                placeholder="Enter new discount"
                fullWidth
                size="small"
                value={newDiscount}
                onChange={(e) => setNewDiscount(e.target.value)}
              />
              <TextField
                select
                label="Type"
                fullWidth
                size="small"
                value={newDiscountType}
                onChange={(e) => setNewDiscountType(e.target.value)}
              >
                <MenuItem value="%">%</MenuItem>
                <MenuItem value="₹">₹</MenuItem>
              </TextField>
            </Stack>
          </Stack>
        </Box>

        <DialogActions sx={{ pr: 3, pb: 2 }}>
          <Button
            variant="outlined"
            color="error"
            onClick={() => setApplyDiscountOpen(false)}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="warning"
            onClick={() => handleDiscountSubmit(selectInvoiceForMore)}
          >
            Apply
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={changeDocCentOpen}
        onClose={() => setChangeDocCentOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Change Doctor and Centre</DialogTitle>
        <Box sx={{ px: 3, pt: 2 }}>
          <Stack spacing={2} direction="row">
            <TextField
              label="Current Doctor"
              value={selectInvoiceForMore?.doctor?.name}
              disabled
              fullWidth
              size="small"
              sx
            />
            <TextField
              label="Current Centre"
              value={selectInvoiceForMore?.center?.centreName}
              disabled
              fullWidth
              size="small"
              sx
            />
          </Stack>
          <Stack spacing={2} direction="row" mt={2}>
            <Autocomplete
              options={doctorSuggestions}
              getOptionLabel={(option) => `${option.name} (${option.regId})`}
              loading={loadingDoctors}
              // value={
              //   invoice && formData && formData.doctorId && formData.doctorId
              // }
              fullWidth
              onInputChange={(e, value) => setDoctorSearchInput(value)}
              onChange={handleSelectDoctor}
              renderOption={(props, option, { inputValue }) => {
                const nameParts = parse(
                  option.name,
                  match(option.name, inputValue),
                );
                const idParts = parse(
                  option.regId,
                  match(option.regId, inputValue),
                );

                return (
                  <Box
                    component="li"
                    {...props}
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      justifyContent: "flex-start",
                      p: 1.2,
                      borderBottom: "1px solid #eee",
                      width: "100%",
                      "&:hover": { backgroundColor: "#f0f4f8" },
                    }}
                  >
                    <Typography
                      variant="subtitle2"
                      fontWeight={600}
                      sx={{ textAlign: "left", width: "100%" }}
                    >
                      {nameParts.map((part, index) => (
                        <span
                          key={index}
                          style={{
                            fontWeight: part.highlight ? 700 : 400,
                            backgroundColor: part.highlight
                              ? "#ffe082"
                              : "transparent",
                            padding: "2px",
                            borderRadius: "3px",
                          }}
                        >
                          {part.text}
                        </span>
                      ))}
                    </Typography>

                    <Typography
                      variant="caption"
                      color="text.secondary"
                      sx={{ textAlign: "left", width: "100%" }}
                    >
                      ID:{" "}
                      {idParts.map((part, index) => (
                        <span
                          key={index}
                          style={{
                            fontWeight: part.highlight ? 600 : 400,
                            backgroundColor: part.highlight
                              ? "#ffe082"
                              : "transparent",
                          }}
                        >
                          {part.text}
                        </span>
                      ))}
                    </Typography>
                  </Box>
                );
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Search Doctor"
                  variant="outlined"
                  size="small"
                  sx={{ backgroundColor: "#fff" }}
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        {loadingDoctors ? (
                          <CircularProgress color="inherit" size={20} />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </>
                    ),
                  }}
                />
              )}
              noOptionsText={
                doctorSearchInput.trim() ? (
                  <Box>
                    <Typography variant="body2" sx={{ mb: 1 }}>
                      No doctor found.
                    </Typography>
                    <Button variant="contained" size="small">
                      Register
                    </Button>
                  </Box>
                ) : (
                  "Search by: Reg.Id or Name"
                )
              }
            />
            <Autocomplete
              options={centerSuggestions}
              getOptionLabel={(option) =>
                `${option.centreName} (${option.centreId})`
              }
              loading={loadingCenters}
              fullWidth
              onInputChange={(e, value) => setCenterSearchInput(value)}
              onChange={handleSelectCenter}
              renderOption={(props, option, { inputValue }) => {
                const nameParts = parse(
                  option.centreName,
                  match(option.centreName, inputValue),
                );
                const idParts = parse(
                  option.centreId,
                  match(option.centreId, inputValue),
                );

                return (
                  <Box
                    component="li"
                    {...props}
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      justifyContent: "flex-start",
                      p: 1.2,
                      borderBottom: "1px solid #eee",
                      width: "100%",
                      "&:hover": { backgroundColor: "#f0f4f8" },
                    }}
                  >
                    <Typography
                      variant="subtitle2"
                      fontWeight={600}
                      sx={{ textAlign: "left", width: "100%" }}
                    >
                      {nameParts.map((part, index) => (
                        <span
                          key={index}
                          style={{
                            fontWeight: part.highlight ? 700 : 400,
                            backgroundColor: part.highlight
                              ? "#ffe082"
                              : "transparent",
                            padding: "2px",
                            borderRadius: "3px",
                          }}
                        >
                          {part.text}
                        </span>
                      ))}
                    </Typography>

                    <Typography
                      variant="caption"
                      color="text.secondary"
                      sx={{ textAlign: "left", width: "100%" }}
                    >
                      ID:{" "}
                      {idParts.map((part, index) => (
                        <span
                          key={index}
                          style={{
                            fontWeight: part.highlight ? 600 : 400,
                            backgroundColor: part.highlight
                              ? "#ffe082"
                              : "transparent",
                          }}
                        >
                          {part.text}
                        </span>
                      ))}
                    </Typography>
                  </Box>
                );
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Search Centre"
                  variant="outlined"
                  size="small"
                  sx={{ backgroundColor: "#fff" }}
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        {loadingCenters ? (
                          <CircularProgress color="inherit" size={20} />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </>
                    ),
                  }}
                />
              )}
              noOptionsText={
                centerSearchInput.trim() ? (
                  <Box>
                    <Typography variant="body2" sx={{ mb: 1 }}>
                      No center found.
                    </Typography>
                    <Button variant="contained" size="small">
                      Register
                    </Button>
                  </Box>
                ) : (
                  "Search by: Centre Id or Name"
                )
              }
            />
          </Stack>
        </Box>

        <DialogActions sx={{ pr: 3, pb: 2 }}>
          <Button
            variant="outlined"
            color="error"
            onClick={() => setChangeAmtOpen(false)}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="warning"
            disabled={loadingDocCent}
            onClick={changeDoctorCentre} // Replace with your actual handler
          >
            {loadingDocCent ? <CircularProgress size={25} /> : "Change"}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={changeAmtOpen}
        onClose={() => setChangeAmtOpen(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>Change Collected Amount</DialogTitle>

        <Box sx={{ px: 3, pt: 2 }}>
          <Stack spacing={2}>
            <TextField
              label="Collected Amount"
              value={selectInvoiceForMore?.amountCollected || 0}
              disabled
              fullWidth
              size="small"
              sx
            />
            <TextField
              label="New Amount"
              placeholder="Enter new amount"
              fullWidth
              size="small"
              value={collectedAmt}
              type="number"
              onChange={(e) => setCollectedAmt(e.target.value)}
            />
          </Stack>
        </Box>

        <DialogActions sx={{ pr: 3, pb: 2 }}>
          <Button
            variant="outlined"
            color="error"
            onClick={() => setChangeAmtOpen(false)}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="warning"
            disabled={amtLoading}
            onClick={() => handleCollectAmtSubmit(selectInvoiceForMore)} // Replace with your actual handler
          >
            {amtLoading ? <CircularProgress size={25} /> : "Change"}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openModal}
        onClose={() => setOpenModal(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>Choose paper particulars</DialogTitle>
        <DialogContent
          sx={{
            paddingTop: "10px !important",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <FormControl fullWidth>
            <InputLabel>Paper Size</InputLabel>
            <Select
              value={paperSize}
              label="Paper Size"
              onChange={(e) => setPaperSize(e.target.value)}
            >
              <MenuItem value="a4">A4</MenuItem>
              <MenuItem value="a5">A5</MenuItem>
            </Select>
          </FormControl>

          <FormControl fullWidth sx={{ marginLeft: "10px" }}>
            <InputLabel>Orientation</InputLabel>
            <Select
              value={orientation}
              label="Orientation"
              onChange={(e) => setOrientation(e.target.value)}
            >
              <MenuItem value="portrait">Portrait</MenuItem>
              <MenuItem value="landscape">Landscape</MenuItem>
            </Select>
          </FormControl>
          {selectedInvoiceToPrint &&
            (!printLoading ? (
              <IconButton size="small" sx={{ ml: 1 }}>
                <LocalPrintshopIcon
                  onClick={printInvoice}
                  sx={{
                    cursor: "pointer",
                    color: "#26a96c",
                    fontSize: "2.2rem",
                  }}
                />
              </IconButton>
            ) : (
              <Typography>Printing...</Typography>
            ))}
          {selectedAdviceToPrint &&
            (!printLoading ? (
              <IconButton size="small" sx={{ ml: 1 }}>
                <LocalPrintshopIcon
                  onClick={printAdvice}
                  sx={{
                    cursor: "pointer",
                    color: "#26a96c",
                    fontSize: "2.2rem",
                  }}
                />
              </IconButton>
            ) : (
              <Typography>Printing...</Typography>
            ))}
        </DialogContent>
      </Dialog>
      {/* {invoices && ( */}
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginTop: 5,
            marginLeft: 5,
          }}
        >
          <input
            type="date"
            value={fromDate}
            onChange={(e) => {
              setFromDate(e.target.value); // Store in YYYY-MM-DD for input
              setFormattedFromDate(formatDateToReadableString(e.target.value)); // Store in readable format
            }}
            style={{
              // width: "100%",
              padding: "6px 8px",
              fontSize: "14px",
              borderRadius: "6px",
              border: "1px solid #ddd",
              outline: "none",
              transition: "all 0.3s ease-in-out",
              boxShadow: "inset 0 1px 3px rgba(0, 0, 0, 0.1)",
              marginRight: 5,
            }}
          />
          {/* <Typography>To: </Typography> */}
          <EastIcon />
          <input
            type="date"
            value={toDate} // Bind with the correct format for the input
            onChange={(e) => {
              setToDate(e.target.value); // Store in YYYY-MM-DD for input
              setFormattedToDate(formatDateToReadableString(e.target.value)); // Store in readable format
            }}
            style={{
              // width: "100%",
              padding: "6px 8px",
              fontSize: "14px",
              borderRadius: "6px",
              border: "1px solid #ddd",
              outline: "none",
              transition: "all 0.3s ease-in-out",
              boxShadow: "inset 0 1px 3px rgba(0, 0, 0, 0.1)",
            }}
          />
          {fromDate && toDate && (
            <ContentPasteSearchIcon
              onClick={handleSearchInvoice}
              sx={{ fontSize: "2rem", color: "#ef2d56", cursor: "pointer" }}
            />
          )}
        </div>
        {invoices && (
          <TablePagination
            component="div"
            // count={filteredinvoices?.length}
            count={totalInvoiceCount}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            rowsPerPageOptions={[5, 10, 25]}
          />
        )}
      </Box>
      <TableContainer
        component={Paper}
        elevation={3}
        sx={{
          borderRadius: "16px",
          overflow: "hidden",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            p: 1,
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              flexWrap: "wrap",
              gap: 1,
            }}
          >
            {/* Total Invoices */}
            <Box
              sx={{
                display: "inline-flex",
                alignItems: "center",
                backgroundColor: "#f0fdf4",
                borderRadius: "8px",
                border: "1px solid #0e903cff",
                boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
                height: 36,
                px: 1.5,
              }}
            >
              <Typography
                sx={{
                  color: "#166534",
                  fontSize: "0.9rem",
                  fontWeight: 600,
                }}
              >
                {totalInvoiceCount || 0} Invoices
              </Typography>
            </Box>

            {/* Grand Total */}
            <Box
              sx={{
                display: "inline-flex",
                alignItems: "center",
                backgroundColor: "#fff1f2",
                borderRadius: "8px",
                border: "1px solid #fecdd3",
                boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
                height: 36,
                px: 1.5,
              }}
            >
              <Typography
                sx={{ color: "#b91c1c", fontSize: "0.9rem", fontWeight: 600 }}
              >
                Grand Total: ₹ {invoiceGTotal ? invoiceGTotal.toFixed(2) : 0}
              </Typography>
            </Box>

            {/* Discount */}
            <Box
              sx={{
                display: "inline-flex",
                alignItems: "center",
                backgroundColor: "#fefce8",
                borderRadius: "8px",
                border: "1px solid #fef08a",
                boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
                height: 36,
                px: 1.5,
              }}
            >
              <Typography
                sx={{ color: "#854d0e", fontSize: "0.9rem", fontWeight: 600 }}
              >
                Discount: ₹ {invoiceDiscount ? invoiceDiscount.toFixed(2) : 0}
              </Typography>
            </Box>

            {/* Final Total */}
            <Box
              sx={{
                display: "inline-flex",
                alignItems: "center",
                backgroundColor: "#ecfdf5",
                borderRadius: "8px",
                border: "1px solid #a7f3d0",
                boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
                height: 36,
                px: 1.5,
              }}
            >
              <Typography
                sx={{ color: "#065f46", fontSize: "0.9rem", fontWeight: 600 }}
              >
                Final Total: ₹ {invoiceTotal ? invoiceTotal.toFixed(2) : 0}
              </Typography>
            </Box>

            {/* Due */}
            <Box
              sx={{
                display: "inline-flex",
                alignItems: "center",
                backgroundColor: "#fff7ed",
                borderRadius: "8px",
                border: "1px solid #fed7aa",
                boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
                height: 36,
                px: 1.5,
              }}
            >
              <Typography
                sx={{ color: "#9a3412", fontSize: "0.9rem", fontWeight: 600 }}
              >
                Due: ₹ {invoiceDue ? invoiceDue.toFixed(2) : 0}
              </Typography>
            </Box>
          </Box>

          <TextField
            placeholder="Search invoices"
            variant="outlined"
            size="small"
            value={searchQuery}
            onChange={handleSearch}
            sx={{ width: "20%", ml: "auto" }}
          />
          <button
            onClick={handleReload}
            style={{
              display: "flex",
              alignItems: "center",
              border: "none",
              background: "none",
              cursor: "pointer",
              padding: "8px",
            }}
          >
            <RefreshIcon style={{ color: "#1976d2", fontSize: "24px" }} />
          </button>
        </Box>

        <Table
          sx={{
            borderCollapse: "separate",
            borderSpacing: 0,
            backgroundColor: "#ffffff",
            borderRadius: "12px",
            overflow: "hidden",
            boxShadow: "0 4px 10px rgba(0,0,0,0.06)",
          }}
        >
          <TableHead
            sx={{
              backgroundColor: "#f3f4f6",
              "& .MuiTableCell-head": {
                fontWeight: 700,
                fontSize: "11px",
                color: "#374151",
                textTransform: "uppercase",
                letterSpacing: 0.5,
                padding: "12px",
                borderBottom: "1px solid #e5e7eb",
              },
            }}
          >
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Bill Date</TableCell>
              <TableCell>Patient</TableCell>
              <TableCell>Doctor</TableCell>
              <TableCell>Centre</TableCell>
              <TableCell>Grand Total</TableCell>
              <TableCell>Discount</TableCell>
              <TableCell>Final Total</TableCell>
              <TableCell>Due</TableCell>
              <TableCell width={"200px"} align="center">
                Action
              </TableCell>
            </TableRow>
            {rowLoading && (
              <TableRow>
                <TableCell colSpan={10} sx={{ padding: 0 }}>
                  <LinearProgress
                    color="success"
                    sx={{ height: 2, width: "100%" }}
                  />
                </TableCell>
              </TableRow>
            )}
          </TableHead>
          <TableBody>
            {invoices ? (
              invoices?.map((invoice, index) => {
                const printOpen = Boolean(printAnchorEls[invoice._id]);
                const actionOpen = Boolean(actionAnchorEls[invoice._id]);
                const moreOpen = Boolean(moreAnchorEls[invoice._id]);
                return (
                  <TableRow
                    key={invoice._id}
                    sx={{
                      position: "relative",
                      fontSize: "11px",
                      "&:hover": {
                        backgroundColor: "#f1f8ff",
                        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                      },
                      transition:
                        "background-color 0.2s ease, box-shadow 0.2s ease",
                      "& .invoiceId": {
                        transition: "transform 0.2s ease, opacity 0.2s ease",
                      },
                      "&:hover .invoiceId": {
                        transform: "translateY(-5px)",
                      },
                      "&:hover .viewLogBtn": {
                        opacity: 1,
                        visibility: "visible",
                      },
                    }}
                  >
                    <TableCell>
                      <Box className="invoiceId">{invoice?.invoiceId}</Box>
                      {user?._doc?.role === "Admin" && (
                        <Typography
                          className="viewLogBtn"
                          color="warning"
                          onClick={() => handleViewLog(invoice?._id)}
                          sx={{
                            fontSize: "0.75rem",
                            cursor: "pointer",
                            position: "absolute",
                            top: "54%",
                            left: "15px",
                            mt: "2px",
                            opacity: 0,
                            visibility: "hidden",
                            transition:
                              "opacity 0.2s ease, visibility 0.2s ease",
                          }}
                        >
                          <FormatAlignLeftIcon sx={{ fontSize: "1rem" }} />
                          view logs
                        </Typography>
                      )}
                    </TableCell>
                    <TableCell>{invoice?.billingDate}</TableCell>
                    <TableCell>{invoice?.patientName}</TableCell>
                    <TableCell>{invoice?.doctorName}</TableCell>
                    <TableCell>{invoice?.centerName}</TableCell>
                    <TableCell>
                      <Chip
                        label={`₹ ${invoice?.calculations?.grandTotal.toFixed(
                          2,
                        )}`}
                        sx={{ backgroundColor: "#ffccd5" }}
                      />
                    </TableCell>
                    <TableCell>
                      <Chip
                        label={`₹ ${invoice?.calculations?.totalDiscountOffered.toFixed(
                          2,
                        )}`}
                        sx={{ backgroundColor: "#fcefb4" }}
                      />
                    </TableCell>
                    <TableCell>
                      <Chip
                        label={`₹ ${invoice?.calculations?.finalTotal.toFixed(
                          2,
                        )}`}
                        sx={{ backgroundColor: "#c7f9cc" }}
                      />
                    </TableCell>
                    <TableCell>
                      <Chip
                        label={`₹ ${invoice?.due?.toFixed(2)}`}
                        variant="outlined"
                        color="warning"
                      />
                    </TableCell>
                    <TableCell>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-evenly",
                          alignItems: "center",
                        }}
                      >
                        {editingRow === index ? (
                          dateInputVisible ? (
                            <>
                              <Tooltip
                                title={`₹ ${amount}`}
                                arrow
                                placement="left"
                                open
                              >
                                <input
                                  ref={dateInputRef}
                                  type="date"
                                  value={formatDateForInput(selectedDate)} // Convert to 'YYYY-MM-DD' for input
                                  onChange={(e) => {
                                    const [year, month, day] =
                                      e.target.value.split("-");
                                    setSelectedDate(`${day}-${month}-${year}`); // Store in 'DD-MM-YYYY' format
                                  }}
                                  style={{
                                    width: "100%",
                                    padding: "6px 8px",
                                    fontSize: "14px",
                                    borderRadius: "6px",
                                    border: "1px solid #ddd",
                                    outline: "none",
                                    transition: "all 0.3s ease-in-out",
                                    boxShadow:
                                      "inset 0 1px 3px rgba(0, 0, 0, 0.1)",
                                  }}
                                  min={(() => {
                                    const billingDate = new Date(
                                      invoice.billingDate,
                                    );
                                    billingDate.setDate(
                                      billingDate.getDate() + 1,
                                    ); // Increment the date by 1 day
                                    return billingDate
                                      .toISOString()
                                      .split("T")[0]; // Convert to 'YYYY-MM-DD'
                                  })()}
                                  max={new Date().toISOString().split("T")[0]}
                                  onKeyDown={(e) => {
                                    const allowedKeys = [
                                      "Tab",
                                      "ArrowLeft",
                                      "ArrowRight",
                                      "ArrowUp",
                                      "ArrowDown",
                                      "Backspace",
                                      "Delete",
                                      "Esc",
                                    ];
                                    if (!allowedKeys.includes(e.key)) {
                                      e.preventDefault(); // Prevent other key inputs (typing)
                                    }
                                  }}
                                />
                              </Tooltip>
                              {selectedDate && (
                                <IconButton
                                  size="small"
                                  onClick={() => handleConfirmDate(invoice._id)}
                                  color="success"
                                >
                                  <CheckIcon />
                                </IconButton>
                              )}
                              <IconButton
                                size="small"
                                onClick={handleCancelInput}
                                color="error"
                              >
                                <CloseIcon />
                              </IconButton>
                            </>
                          ) : (
                            <>
                              <input
                                ref={amountInputRef}
                                type="number"
                                value={amount}
                                onChange={(e) => {
                                  if (e.target.value > invoice.due) {
                                    return;
                                  }
                                  setAmount(e.target.value);
                                }}
                                placeholder="Enter amount"
                                style={{
                                  width: "100%",
                                  padding: "6px 8px",
                                  fontSize: "14px",
                                  borderRadius: "6px",
                                  border: "1px solid #38a3a5",
                                  outline: "none",
                                  transition: "all 0.3s ease-in-out",
                                  backgroundColor: "#c7f9cc",
                                  color: "#38a3a5",
                                  boxShadow:
                                    "inset 0 1px 3px rgba(0, 0, 0, 0.1)",
                                }}
                                onFocus={(e) =>
                                  (e.target.style.borderColor = "#38a3a5")
                                }
                                onBlur={(e) =>
                                  (e.target.style.borderColor = "#ddd")
                                }
                              />
                              {amount > 0 && (
                                <IconButton
                                  size="small"
                                  onClick={handleConfirmAmount}
                                  color="success"
                                >
                                  <CheckIcon />
                                </IconButton>
                              )}
                              <IconButton
                                size="small"
                                onClick={handleCancelInput}
                                color="error"
                              >
                                <CloseIcon />
                              </IconButton>
                            </>
                          )
                        ) : (
                          <>
                            <>
                              <Box key={invoice._id} display="inline-block">
                                <Tooltip
                                  title="Print Options"
                                  arrow
                                  placement="top"
                                >
                                  <IconButton
                                    size="small"
                                    onClick={(e) =>
                                      handlePrintClick(e, invoice._id)
                                    }
                                  >
                                    <PrintIcon sx={{ color: "#dc0073" }} />
                                  </IconButton>
                                </Tooltip>

                                <Popover
                                  open={printOpen}
                                  anchorEl={printAnchorEls[invoice._id]}
                                  onClose={() => handlePrintClose(invoice._id)}
                                  anchorOrigin={{
                                    vertical: "top",
                                    horizontal: "center",
                                  }}
                                  transformOrigin={{
                                    vertical: "bottom",
                                    horizontal: "center",
                                  }}
                                  PaperProps={{
                                    sx: {
                                      p: 1,
                                      mt: 1,
                                      "&::before": {
                                        content: '""',
                                        position: "absolute",
                                        top: "100%",
                                        left: "50%",
                                        transform: "translateX(-50%)",
                                        width: 0,
                                        height: 0,
                                        borderLeft: "8px solid transparent",
                                        borderRight: "8px solid transparent",
                                        borderTop: "8px solid white",
                                        zIndex: 1,
                                      },
                                    },
                                  }}
                                >
                                  <Box
                                    display="flex"
                                    flexDirection="column"
                                    gap={0.5}
                                  >
                                    <List dense sx={{ p: 0 }}>
                                      <ListItemButton
                                        onClick={() => {
                                          handleInvoiceClick(invoice._id);
                                          handlePrintClose(invoice._id);
                                        }}
                                      >
                                        <ListItemIcon sx={{ minWidth: 32 }}>
                                          <ReceiptIcon
                                            fontSize="small"
                                            sx={{ color: "green" }}
                                          />
                                        </ListItemIcon>
                                        <ListItemText primary="Print Invoice" />
                                      </ListItemButton>

                                      <ListItemButton
                                        onClick={() => {
                                          handleAdviceClick(invoice._id);
                                          handlePrintClose(invoice._id);
                                        }}
                                      >
                                        <ListItemIcon sx={{ minWidth: 32 }}>
                                          <DescriptionIcon
                                            fontSize="small"
                                            sx={{ color: "#f59e0b" }}
                                          />
                                        </ListItemIcon>
                                        <ListItemText primary="Print Advice" />
                                      </ListItemButton>

                                      <ListItemButton
                                        onClick={() => {
                                          handleBothClick(invoice._id);
                                        }}
                                        sx={{
                                          borderTop: "1px solid #e5e7eb",
                                          mt: 0.5,
                                        }}
                                      >
                                        <ListItemIcon sx={{ minWidth: 32 }}>
                                          <DynamicFeedIcon
                                            fontSize="small"
                                            sx={{ color: "#dc2626" }}
                                          />
                                        </ListItemIcon>
                                        <ListItemText primary="Print Both" />
                                      </ListItemButton>
                                    </List>
                                  </Box>
                                </Popover>
                              </Box>
                            </>

                            <>
                              <Box key={invoice._id} display="inline-block">
                                <Tooltip
                                  title="Edit / Delete"
                                  arrow
                                  placement="top"
                                >
                                  <IconButton
                                    size="small"
                                    onClick={(e) =>
                                      handleActionClick(e, invoice._id)
                                    }
                                  >
                                    <DeleteSweepIcon
                                      sx={{ color: "#7209b7" }}
                                    />
                                  </IconButton>
                                </Tooltip>

                                <Popover
                                  open={actionOpen}
                                  anchorEl={actionAnchorEls[invoice._id]}
                                  onClose={() => handleActionClose(invoice._id)}
                                  anchorOrigin={{
                                    vertical: "top",
                                    horizontal: "center",
                                  }}
                                  transformOrigin={{
                                    vertical: "bottom",
                                    horizontal: "center",
                                  }}
                                  PaperProps={{
                                    sx: {
                                      p: 1,
                                      mt: 1,
                                      "&::before": {
                                        content: '""',
                                        position: "absolute",
                                        top: "100%",
                                        left: "50%",
                                        transform: "translateX(-50%)",
                                        width: 0,
                                        height: 0,
                                        borderLeft: "8px solid transparent",
                                        borderRight: "8px solid transparent",
                                        borderTop: "8px solid white",
                                        zIndex: 1,
                                      },
                                    },
                                  }}
                                >
                                  <Box display="flex" gap={1}>
                                    {user?._doc?.permissions?.billManagement
                                      ?.edit && (
                                      <Tooltip
                                        title="Edit Invoice"
                                        arrow
                                        placement="top"
                                      >
                                        <IconButton size="small">
                                          <EditIcon
                                            color="primary"
                                            sx={{ cursor: "pointer" }}
                                            onClick={() => handleEdit(invoice)}
                                          />
                                        </IconButton>
                                      </Tooltip>
                                    )}
                                    {!submitStatus &&
                                      user?._doc?.permissions?.billManagement
                                        ?.delete && (
                                        <Tooltip
                                          title="Delete Invoice"
                                          arrow
                                          placement="top"
                                        >
                                          <IconButton size="small">
                                            <DeleteIcon
                                              color="error"
                                              sx={{ cursor: "pointer" }}
                                              onClick={() =>
                                                handleDelete(
                                                  invoice.invoiceId,
                                                  invoice._id,
                                                )
                                              }
                                            />
                                          </IconButton>
                                        </Tooltip>
                                      )}
                                  </Box>
                                </Popover>
                              </Box>
                            </>
                            <Tooltip title="Collect" arrow placement="top">
                              <IconButton
                                size="small"
                                onClick={() => handleCollectClick(index)}
                              >
                                <PointOfSaleIcon
                                  sx={{ cursor: "pointer", color: "#008000" }}
                                />
                              </IconButton>
                            </Tooltip>
                            <>
                              <Box
                                key={invoice._id}
                                display="flex"
                                alignItems="center"
                                gap={1}
                              >
                                <Tooltip title="More" arrow placement="top">
                                  <IconButton
                                    disabled={user?._doc?.role !== "Admin"}
                                    onClick={(e) =>
                                      handleMoreClick(e, invoice._id, invoice)
                                    }
                                    size="small"
                                  >
                                    <MoreVertIcon sx={{ color: "#555" }} />
                                  </IconButton>
                                </Tooltip>
                                <Tooltip
                                  componentsProps={{
                                    tooltip: {
                                      sx: {
                                        backgroundColor: "transparent",
                                        boxShadow: "none",
                                        p: 0,
                                        m: 0,
                                      },
                                    },
                                  }}
                                  title={
                                    <Alert
                                      severity="info"
                                      sx={{
                                        fontSize: "13px",
                                        maxWidth: 280,
                                        lineHeight: 1.5,
                                      }}
                                    >
                                      <strong>Admin only:</strong>
                                      <ul>
                                        <li>
                                          1. Apply discount on total price even
                                          after report submission
                                        </li>
                                        <li>
                                          2. Changing the collected amount
                                        </li>
                                        <li>
                                          3. Changing the Doctor and Centre
                                        </li>
                                      </ul>
                                    </Alert>
                                  }
                                  placement="left"
                                >
                                  <InfoOutlinedIcon
                                    fontSize="13px"
                                    sx={{
                                      position: "absolute",
                                      top: "13px",
                                      right: "23px",
                                      fontSize: "14px",
                                      color: "#0288d1",
                                      backgroundColor: "white",
                                      borderRadius: "50%",
                                      padding: "2px",
                                    }}
                                  />
                                </Tooltip>
                                <Popover
                                  open={moreOpen}
                                  anchorEl={moreAnchorEls[invoice._id]}
                                  onClose={() => handleMoreClose(invoice._id)}
                                  anchorOrigin={{
                                    vertical: "top",
                                    horizontal: "center",
                                  }}
                                  transformOrigin={{
                                    vertical: "bottom",
                                    horizontal: "center",
                                  }}
                                  PaperProps={{
                                    sx: {
                                      p: 1,
                                      mt: 1,
                                      borderRadius: 2,
                                      boxShadow: "0 6px 18px rgba(0,0,0,0.1)",
                                      minWidth: 200,
                                      "&::before": {
                                        content: '""',
                                        position: "absolute",
                                        top: "100%",
                                        left: "50%",
                                        transform: "translateX(-50%)",
                                        width: 0,
                                        height: 0,
                                        borderLeft: "8px solid transparent",
                                        borderRight: "8px solid transparent",
                                        borderTop: "8px solid white",
                                      },
                                    },
                                  }}
                                >
                                  {/* Header */}
                                  <Box
                                    display="flex"
                                    justifyContent="space-between"
                                    alignItems="center"
                                    px={1}
                                  >
                                    <Typography
                                      variant="subtitle2"
                                      fontWeight={600}
                                      color="text.secondary"
                                    >
                                      Actions
                                    </Typography>
                                    <IconButton
                                      size="small"
                                      onClick={() =>
                                        handleMoreClose(invoice._id)
                                      }
                                    >
                                      <CloseIcon fontSize="small" />
                                    </IconButton>
                                  </Box>

                                  <Divider sx={{ my: 1 }} />

                                  {/* Action List */}
                                  <List dense sx={{ p: 0 }}>
                                    <ListItemButton
                                      onClick={() => setApplyDiscountOpen(true)}
                                    >
                                      <ListItemIcon sx={{ minWidth: 32 }}>
                                        <DiscountIcon
                                          fontSize="small"
                                          sx={{ color: "#1F2937" }}
                                        />
                                      </ListItemIcon>
                                      <ListItemText
                                        primary="Apply Discount"
                                        primaryTypographyProps={{
                                          fontSize: 14,
                                        }}
                                      />
                                    </ListItemButton>

                                    <ListItemButton
                                      onClick={() => setChangeAmtOpen(true)}
                                    >
                                      <ListItemIcon sx={{ minWidth: 32 }}>
                                        <CurrencyRupeeIcon
                                          fontSize="small"
                                          sx={{ color: "#20db65ff" }}
                                        />
                                      </ListItemIcon>
                                      <ListItemText
                                        primary="Change Collected Amt."
                                        primaryTypographyProps={{
                                          fontSize: 14,
                                        }}
                                      />
                                    </ListItemButton>

                                    <ListItemButton
                                      onClick={() => setChangeDocCentOpen(true)}
                                    >
                                      <ListItemIcon sx={{ minWidth: 32 }}>
                                        <SwapHorizIcon
                                          fontSize="small"
                                          sx={{ color: "#F97316" }}
                                        />
                                      </ListItemIcon>
                                      <ListItemText
                                        primary="Change Doctor / Centre"
                                        primaryTypographyProps={{
                                          fontSize: 14,
                                        }}
                                      />
                                    </ListItemButton>
                                  </List>
                                </Popover>
                              </Box>
                            </>
                            {/* {user?._doc?.permissions?.billManagement?.edit && (
                              <Tooltip
                                title="Edit Invoice"
                                arrow
                                placement="top"
                              >
                                <IconButton size="small">
                                  <EditIcon
                                    color="primary"
                                    sx={{ cursor: "pointer" }}
                                    onClick={() => handleEdit(invoice)}
                                  />
                                </IconButton>
                              </Tooltip>
                            )}
                            {!submitStatus &&
                              user?._doc?.permissions?.billManagement
                                ?.delete && (
                                <Tooltip
                                  title="Delete Invoice"
                                  arrow
                                  placement="top"
                                >
                                  <IconButton size="small">
                                    <DeleteIcon
                                      color="error"
                                      sx={{ cursor: "pointer" }}
                                      onClick={() =>
                                        handleDelete(
                                          invoice.invoiceId,
                                          invoice._id
                                        )
                                      }
                                    />
                                  </IconButton>
                                </Tooltip>
                              )} */}
                            {/* <Tooltip title="Collect" arrow placement="top">
                              <IconButton
                                size="small"
                                onClick={() => handleCollectClick(index)}
                              >
                                <PointOfSaleIcon
                                  sx={{ cursor: "pointer", color: "#008000" }}
                                />
                              </IconButton>
                            </Tooltip> */}
                          </>
                        )}
                      </div>
                    </TableCell>
                  </TableRow>
                );
              })
            ) : (
              <TableRow>
                <TableCell colSpan={8} sx={{ padding: 0 }}>
                  <img
                    src={noData}
                    style={{ margin: "auto" }}
                    width="50%"
                    height="50%"
                  />
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <Log
        openLogDialog={openLogDialog}
        handleCloseLog={handleCloseLog}
        logs={invoiceLogs}
      />
    </Box>
  );
};

export default Invoices;
